import { z } from "zod";

/**
 * ISO 5218 gender codes:
 * 0 = not known
 * 1 = male
 * 2 = female
 * 9 = not applicable
 */
export const GenderSchema = z.union([
    z.literal(0),
    z.literal(1),
    z.literal(2),
    z.literal(9),
]);

export type Gender = z.infer<typeof GenderSchema>;
